var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_MainOrderRegistr"),
        width: "900px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticStyle: { display: "flex", "flex-direction": "column" } },
        [
          _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: !_vm.selectedRow,
                    type: "primary",
                    no: "1"
                  },
                  on: { click: _vm.lookHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.look")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "2" },
                  on: { click: _vm.newHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: !_vm.selectedRow,
                    type: "primary",
                    no: "3"
                  },
                  on: { click: _vm.deleteHandler }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
              )
            ],
            1
          ),
          _c(
            "el-form",
            {
              staticStyle: { "margin-top": "5px" },
              attrs: {
                "label-width": _vm.$selectByLang("100px", "110px"),
                inline: true,
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AirlineCompany") } },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "190px" },
                    attrs: {
                      "select-type": _vm.TYPE_NAMES.basic_data_Company,
                      "method-params": { airCmp: true },
                      filterable: "",
                      "default-value": _vm.filter.airCmpId || "",
                      no: "4"
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.filter.airCmpId = p.value
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.BookingAgent") } },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "190px" },
                    attrs: {
                      "select-type": _vm.TYPE_NAMES.basic_data_Company,
                      "method-params": { bookingAgent: true },
                      filterable: "",
                      "default-value": _vm.filter.bookingAgentId || "",
                      no: "5"
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.filter.bookingAgentId = p.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form",
            {
              attrs: {
                "label-width": _vm.$selectByLang("100px", "110px"),
                inline: true,
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_RegisteredDate") } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "190px" },
                    attrs: {
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      clearable: "",
                      no: "6"
                    },
                    model: {
                      value: _vm.filter.startInputDate,
                      callback: function($$v) {
                        _vm.$set(_vm.filter, "startInputDate", $$v)
                      },
                      expression: "filter.startInputDate"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Message.ShowFromTo2") } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "190px" },
                    attrs: {
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      clearable: "",
                      no: "7"
                    },
                    model: {
                      value: _vm.filter.endInputDate,
                      callback: function($$v) {
                        _vm.$set(_vm.filter, "endInputDate", $$v)
                      },
                      expression: "filter.endInputDate"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "8" },
                  on: { click: _vm.queryHandler }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Query")))]
              )
            ],
            1
          ),
          _c("cargo-ag-grid", {
            staticStyle: { "min-height": "400px" },
            attrs: {
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "9" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Close")))]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "mawb-dialog",
          attrs: {
            visible: _vm.mawbDialog.visible,
            title: _vm.mawbDialog.title,
            width: _vm.$selectByLang("370px", "435px"),
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.mawbDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                disabled: Boolean(_vm.mawbDialog.form.uuid),
                "label-width": _vm.$selectByLang("80px", "145px"),
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_SequenceNumber") } },
                [
                  _c("el-input", {
                    staticClass: "seq-color",
                    staticStyle: { width: "160px" },
                    attrs: { disabled: true, no: "10" },
                    model: {
                      value: _vm.mawbDialog.form.sequence,
                      callback: function($$v) {
                        _vm.$set(_vm.mawbDialog.form, "sequence", $$v)
                      },
                      expression: "mawbDialog.form.sequence"
                    }
                  }),
                  _c("span", { staticClass: "star" }, [_vm._v("*")])
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_InvalidDate") } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "160px" },
                    attrs: {
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      editable: false,
                      clearable: false,
                      no: "11"
                    },
                    model: {
                      value: _vm.mawbDialog.form.effectDate,
                      callback: function($$v) {
                        _vm.$set(_vm.mawbDialog.form, "effectDate", $$v)
                      },
                      expression: "mawbDialog.form.effectDate"
                    }
                  }),
                  _c("span", { staticClass: "star" }, [_vm._v("*")])
                ],
                1
              ),
              _vm.mawbDialog.visible
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.AirlineCompany") } },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "220px" },
                            attrs: {
                              "select-type": _vm.TYPE_NAMES.basic_data_Company,
                              "method-params": { airCmp: true },
                              filterable: "",
                              "default-value":
                                _vm.mawbDialog.form.carrierId || "",
                              no: "12"
                            },
                            on: { parentCallBack: _vm.airCompanyChangeHandler }
                          }),
                          _c(
                            "span",
                            {
                              staticClass: "star",
                              staticStyle: { "margin-top": "5px" }
                            },
                            [_vm._v("*")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm.mawbDialog.visible
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.BookingAgent") } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "220px" },
                        attrs: {
                          "select-type": _vm.TYPE_NAMES.basic_data_Company,
                          "method-params": { bookingAgent: true },
                          filterable: "",
                          "default-value":
                            _vm.mawbDialog.form.bookingAgentId || "",
                          no: "13"
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.mawbDialog.form.bookingAgentId = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_MainOrderStart") } },
                [
                  _c("el-input", {
                    ref: "input1",
                    staticStyle: { width: "40px" },
                    attrs: { value: _vm.mawbDialog.startNo1, no: "14" },
                    on: {
                      input: function($event) {
                        return _vm.handleInput(1, $event)
                      }
                    }
                  }),
                  _vm._v(" - "),
                  _c("el-input", {
                    ref: "input2",
                    staticStyle: { width: "50px" },
                    attrs: { value: _vm.mawbDialog.startNo2, no: "15" },
                    on: {
                      input: function($event) {
                        return _vm.handleInput(2, $event)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("el-input", {
                    ref: "input3",
                    staticStyle: { width: "50px" },
                    attrs: { value: _vm.mawbDialog.startNo3, no: "16" },
                    on: {
                      input: function($event) {
                        return _vm.handleInput(3, $event)
                      }
                    }
                  }),
                  _c("span", { staticClass: "star" }, [_vm._v("*")])
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_TotalCopies") } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "120px" },
                    attrs: {
                      precision: 0,
                      min: 1,
                      max: 9999,
                      "controls-position": "right",
                      placeholder: "1",
                      no: "17"
                    },
                    model: {
                      value: _vm.mawbDialog.form.number,
                      callback: function($$v) {
                        _vm.$set(_vm.mawbDialog.form, "number", $$v)
                      },
                      expression: "mawbDialog.form.number"
                    }
                  }),
                  _c("span", { staticClass: "star" }, [_vm._v("*")])
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AdditionalNotes") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "240px" },
                    attrs: { type: "textarea", rows: 4, no: "18" },
                    model: {
                      value: _vm.mawbDialog.form.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.mawbDialog.form, "remark", $$v)
                      },
                      expression: "mawbDialog.form.remark"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_Acquirer") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "160px" },
                    attrs: { disabled: true, no: "20" },
                    model: {
                      value: _vm.mawbDialog.inputByName,
                      callback: function($$v) {
                        _vm.$set(_vm.mawbDialog, "inputByName", $$v)
                      },
                      expression: "mawbDialog.inputByName"
                    }
                  })
                ],
                1
              ),
              _c("el-form-item", [
                _c(
                  "span",
                  {
                    staticStyle: {
                      color: "red",
                      "padding-left": "10px",
                      "padding-right": "6px"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.AERequiredChecksum")))]
                )
              ]),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_BatchAdd") } },
                [
                  _c("cargo-rich-textarea", {
                    staticStyle: { height: "150px" },
                    attrs: {
                      no: "batchAddNo",
                      "close-on-click-modal": false,
                      "warning-count": _vm.mawbDialog.warningCount,
                      "text-chars": 0,
                      disabled: Boolean(_vm.mawbDialog.form.uuid)
                    },
                    model: {
                      value: _vm.mawbDialog.form.batchAddNo,
                      callback: function($$v) {
                        _vm.$set(_vm.mawbDialog.form, "batchAddNo", $$v)
                      },
                      expression: "mawbDialog.form.batchAddNo"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.mawbDialog.form.uuid,
                      expression: "!mawbDialog.form.uuid"
                    }
                  ],
                  attrs: { type: "primary", no: "21" },
                  on: { click: _vm.saveHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "22" },
                  on: {
                    click: function($event) {
                      _vm.mawbDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
              )
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.advanceTextDialog.visible,
                title: _vm.$t("Message.SaveFailed"),
                width: "300px",
                "append-to-body": "",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.advanceTextDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    color: "red",
                    "padding-left": "10px",
                    "padding-right": "6px"
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("CargoMsg.CARGO_Not_Met_New_Conditions"))
                  )
                ]
              ),
              _c("cargo-rich-textarea", {
                staticStyle: { height: "198px" },
                attrs: {
                  no: "textChars",
                  disabled: true,
                  "close-on-click-modal": false
                },
                model: {
                  value: _vm.advanceTextDialog.value,
                  callback: function($$v) {
                    _vm.$set(_vm.advanceTextDialog, "value", $$v)
                  },
                  expression: "advanceTextDialog.value"
                }
              }),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "close" },
                      on: {
                        click: function($event) {
                          _vm.advanceTextDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }